var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "11 11 7 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 14.966V19h-1v-8h1v3.936a.39.39 0 0 1 .176-.302l5.08-3.545c.277-.202.744-.047.744.348v7.128c0 .395-.501.547-.778.347l-4.977-3.545c-.15-.11-.24-.257-.245-.4"
})));
export default SvgPrevious;